// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__3uGCE","dragIcon":"Choice_dragIcon__3Lyhf","left":"Choice_left__2qpIm","input":"Choice_input__34IST"};